module.exports = __webpack_public_path__ + "staticcomp/img/cover.358b0d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/3/cover.jpg
// module id = 1vYR
// module chunks = 39